import axiosClient from "../../network";

export default class transactionsService {
  static async getTransactions(params) {
    try {
      const { data } = await axiosClient.get("/user/transactions", {
        params,
      });
      return data;
    } catch (error) {
      if (error.data) {
        return { error: error.data };
      }
      return {
        error,
      };
    }
  }

  static async getAllBets(params) {
    try {
      const { data } = await axiosClient.get("/earGaming/getAllBets", {
        params,
      });
      return data;
    } catch (error) {
      if (error.data) {
        return { error: error.data };
      }
      return {
        error,
      };
    }
  }
}
